// Catalog of available connector types ("Todos os conectores"). A maioria
// autentica por API key / token, sem review de app. A exceção é `oauth: true`
// (Google Agenda): o usuário faz login na conta e a Numera guarda os tokens —
// exige app verificado no provedor. Icons use brand logos (clearbit) with a
// colored fallback (see ConnectorIcon). Capabilities live in capabilities.js.
const tokenField = (label = "API key / token") => ({ name: "token", label, secret: true });
const baseField = (placeholder) => ({ name: "baseUrl", label: "Base URL", placeholder });

export const CATALOG = [
  {
    type: "mcp",
    name: "Claude (MCP) — Ligações e SMS",
    description: "Deixe o Claude (e IAs com MCP) fazerem ligações e enviarem SMS pela sua conta. Ligações exigem um número padrão.",
    icon: "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20stroke%3D%22%23D97757%22%20stroke-width%3D%222.1%22%20stroke-linecap%3D%22round%22%3E%3Cline%20x1%3D%2212.00%22%20y1%3D%229.40%22%20x2%3D%2212.00%22%20y2%3D%221.60%22%2F%3E%3Cline%20x1%3D%2213.30%22%20y1%3D%229.75%22%20x2%3D%2216.10%22%20y2%3D%224.90%22%2F%3E%3Cline%20x1%3D%2214.25%22%20y1%3D%2210.70%22%20x2%3D%2221.01%22%20y2%3D%226.80%22%2F%3E%3Cline%20x1%3D%2214.60%22%20y1%3D%2212.00%22%20x2%3D%2220.20%22%20y2%3D%2212.00%22%2F%3E%3Cline%20x1%3D%2214.25%22%20y1%3D%2213.30%22%20x2%3D%2221.01%22%20y2%3D%2217.20%22%2F%3E%3Cline%20x1%3D%2213.30%22%20y1%3D%2214.25%22%20x2%3D%2216.10%22%20y2%3D%2219.10%22%2F%3E%3Cline%20x1%3D%2212.00%22%20y1%3D%2214.60%22%20x2%3D%2212.00%22%20y2%3D%2222.40%22%2F%3E%3Cline%20x1%3D%2210.70%22%20y1%3D%2214.25%22%20x2%3D%227.90%22%20y2%3D%2219.10%22%2F%3E%3Cline%20x1%3D%229.75%22%20y1%3D%2213.30%22%20x2%3D%222.99%22%20y2%3D%2217.20%22%2F%3E%3Cline%20x1%3D%229.40%22%20y1%3D%2212.00%22%20x2%3D%223.80%22%20y2%3D%2212.00%22%2F%3E%3Cline%20x1%3D%229.75%22%20y1%3D%2210.70%22%20x2%3D%222.99%22%20y2%3D%226.80%22%2F%3E%3Cline%20x1%3D%2210.70%22%20y1%3D%229.75%22%20x2%3D%227.90%22%20y2%3D%224.90%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E",
    color: "#D97757",
    native: true, // sem credenciais — instruções + ativar
    fields: [],
  },
  {
    type: "google",
    name: "Google Agenda",
    description: "Consultar disponibilidade, criar e cancelar compromissos na agenda do usuário.",
    icon: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg",
    color: "#1A73E8",
    oauth: true, // login na conta Google — sem campos de credencial
    fields: [],
  },
  {
    type: "brchat",
    name: "BR CHAT",
    description: "WhatsApp NÃO oficial (API não oficial) — enviar e receber mensagens",
    icon: "https://logo.clearbit.com/whatsapp.com",
    color: "#25D366",
    fields: [baseField("https://cliente2.numera.chat"), tokenField("Token da conexão (x_token)")],
  },
  {
    type: "whatsapp_qr",
    name: "WhatsApp (QRCode)",
    description:
      "WhatsApp NÃO oficial via QR Code.  Pareie escaneando o QR com o celular. Risco de bloqueio do número: use um chip dedicado.",
    icon: "https://logo.clearbit.com/whatsapp.com",
    color: "#25D366",
    qr: true, // pareamento por QR Code (sem campos de credencial)
    fields: [],
  },
  {
    type: "atende",
    name: "Numera Atende",
    description:
      "Console de atendimento humano. Habilita a ferramenta 'Transferir para humano' e o espelhamento das conversas da IA para os atendentes.",
    color: "#0B7285",
    fields: [
      baseField("https://atende.suaempresa.com/atende-api/api/v1/studio"),
      { name: "token", label: "Token do tenant (Bearer)", secret: true },
      { name: "inboundSecret", label: "Segredo de entrada (o Studio assina — X-Studio-Signature)", secret: true },
      { name: "outboundSecret", label: "Segredo de saída (o Studio valida — X-Atende-Signature)", secret: true },
    ],
  },
  {
    type: "smtp",
    name: "E-mail (SMTP)",
    description: "Enviar e-mail por qualquer servidor SMTP (Gmail, SES, Brevo, próprio…)",
    icon: "",
    color: "#0B7285",
    fields: [
      { name: "host", label: "Servidor SMTP (host)", placeholder: "smtp.gmail.com" },
      { name: "port", label: "Porta", placeholder: "587 (TLS) ou 465 (SSL)" },
      { name: "user", label: "Usuário" },
      { name: "pass", label: "Senha", secret: true },
      { name: "fromEmail", label: "Remetente (e-mail)", placeholder: "no-reply@seudominio.com" },
      { name: "fromName", label: "Nome do remetente", placeholder: "Sua Empresa" },
    ],
  },
  {
    type: "gupshup",
    name: "WhatsApp - API Oficial",
    description: "WhatsApp OFICIAL — mensagens e templates",
    icon: "https://logo.clearbit.com/whatsapp.com",
    color: "#25D366",
    // endpoint fixo (api.gupshup.io); só apikey + número source + nome do app
    fields: [
      tokenField("API key (apikey)"),
      { name: "source", label: "Número (source)", placeholder: "5511999999999" },
      { name: "appName", label: "Nome do app (src.name)" },
    ],
  },
  {
    type: "rdstation",
    name: "RD Station",
    description: "CRM e automação de marketing",
    icon: "https://logo.clearbit.com/rdstation.com",
    color: "#5C16C5",
    fields: [baseField("https://crm.rdstation.com/api/v1"), tokenField()],
  },
  {
    type: "pipedrive",
    name: "Pipedrive",
    description: "CRM de vendas",
    icon: "https://logo.clearbit.com/pipedrive.com",
    color: "#0B1B2B",
    fields: [baseField("https://SEU.pipedrive.com/api/v1"), tokenField("API token")],
  },
  {
    type: "bitrix",
    name: "Bitrix24",
    description: "CRM e colaboração",
    icon: "https://logo.clearbit.com/bitrix24.com",
    color: "#2FC7F7",
    fields: [baseField("https://SEU.bitrix24.com/rest/1/<webhook>")],
  },
  {
    type: "ploomes",
    name: "Ploomes",
    description: "CRM",
    icon: "https://logo.clearbit.com/ploomes.com",
    color: "#0A6CFF",
    fields: [baseField("https://public-api2.ploomes.com"), tokenField("User-Key")],
  },
  {
    type: "agendor",
    name: "Agendor",
    description: "CRM",
    icon: "https://logo.clearbit.com/agendor.com.br",
    color: "#00B2A9",
    fields: [baseField("https://api.agendor.com.br/v3"), tokenField()],
  },
  {
    type: "hubspot",
    name: "HubSpot",
    description: "CRM e marketing",
    icon: "https://logo.clearbit.com/hubspot.com",
    color: "#FF7A59",
    fields: [baseField("https://api.hubapi.com"), tokenField("Private App token")],
  },
  {
    type: "bling",
    name: "Bling",
    description: "ERP — pedidos, produtos, frete",
    icon: "https://logo.clearbit.com/bling.com.br",
    color: "#00A859",
    fields: [baseField("https://api.bling.com.br/Api/v3"), tokenField()],
  },
  {
    type: "tiny",
    name: "Tiny (Olist)",
    description: "ERP — pedidos, produtos, NF",
    icon: "https://logo.clearbit.com/tiny.com.br",
    color: "#1B9E4B",
    fields: [baseField("https://api.tiny.com.br/api2"), tokenField()],
  },
  {
    type: "omie",
    name: "Omie",
    description: "ERP — clientes, financeiro",
    icon: "https://logo.clearbit.com/omie.com.br",
    color: "#0E9BD6",
    fields: [baseField("https://app.omie.com.br/api/v1"), { name: "appKey", label: "App Key" }, { name: "token", label: "App Secret", secret: true }],
  },
  {
    type: "mautic",
    name: "Mautic",
    description: "Automação de marketing (open source)",
    icon: "https://logo.clearbit.com/mautic.org",
    color: "#4E5E9E",
    fields: [baseField("https://SEU-mautic.com"), tokenField("Token / Basic auth")],
  },
  {
    type: "activecampaign",
    name: "ActiveCampaign",
    description: "Automação de marketing",
    icon: "https://logo.clearbit.com/activecampaign.com",
    color: "#356AE6",
    fields: [baseField("https://SUACONTA.api-us1.com"), tokenField("Api-Token")],
  },
  {
    type: "brevo",
    name: "Brevo",
    description: "E-mail e SMS",
    icon: "https://logo.clearbit.com/brevo.com",
    color: "#0B996E",
    fields: [baseField("https://api.brevo.com/v3"), tokenField("api-key")],
  },
  {
    type: "movidesk",
    name: "Movidesk",
    description: "Helpdesk — tickets",
    icon: "https://logo.clearbit.com/movidesk.com",
    color: "#1466B8",
    fields: [baseField("https://api.movidesk.com/public/v1"), tokenField()],
  },
  {
    type: "zendesk",
    name: "Zendesk",
    description: "Helpdesk — tickets",
    icon: "https://logo.clearbit.com/zendesk.com",
    color: "#03363D",
    fields: [baseField("https://SUA.zendesk.com/api/v2"), tokenField()],
  },
  {
    type: "asaas",
    name: "Asaas",
    description: "Cobrança e pagamentos",
    icon: "https://logo.clearbit.com/asaas.com",
    color: "#1542B5",
    fields: [baseField("https://api.asaas.com/v3"), tokenField("access_token")],
  },
  {
    type: "iugu",
    name: "Iugu",
    description: "Cobrança e pagamentos",
    icon: "https://logo.clearbit.com/iugu.com",
    color: "#125CFF",
    fields: [baseField("https://api.iugu.com/v1"), tokenField()],
  },
  {
    type: "mercadopago",
    name: "Mercado Pago",
    description: "Pagamentos",
    icon: "https://logo.clearbit.com/mercadopago.com.br",
    color: "#009EE3",
    fields: [baseField("https://api.mercadopago.com"), tokenField("Access token")],
  },
  {
    // O token do bot vai no CAMINHO da URL (api.telegram.org/bot<TOKEN>/...),
    // não em cabeçalho — por isso não há Base URL aqui: ela é montada a partir
    // do token em flow/executors/connector.ts (baseFor).
    type: "telegram",
    name: "Telegram",
    description:
      "Enviar mensagens, fotos e documentos por um bot do Telegram. Crie o bot no @BotFather e cole o token aqui.",
    icon: "https://logo.clearbit.com/telegram.org",
    color: "#229ED9",
    fields: [tokenField("Token do bot (do @BotFather)")],
  },
  {
    type: "zenvia",
    name: "Zenvia",
    description: "SMS e WhatsApp",
    icon: "https://logo.clearbit.com/zenvia.com",
    color: "#FF4646",
    fields: [baseField("https://api.zenvia.com/v2"), tokenField("X-API-TOKEN")],
  },
  {
    type: "calendly",
    name: "Calendly",
    description: "Agendamento",
    icon: "https://logo.clearbit.com/calendly.com",
    color: "#006BFF",
    fields: [baseField("https://api.calendly.com"), tokenField()],
  },
  {
    type: "airtable",
    name: "Airtable",
    description: "Base de dados / registros",
    icon: "https://logo.clearbit.com/airtable.com",
    color: "#FCB400",
    fields: [baseField("https://api.airtable.com/v0"), tokenField("Personal access token")],
  },
  {
    type: "webhook",
    name: "Webhook genérico",
    description: "Zapier / Make / n8n — ponte universal",
    icon: "https://logo.clearbit.com/zapier.com",
    color: "#FF4F00",
    fields: [baseField("https://hook... (URL do Zapier/Make/n8n)")],
  },
  {
    type: "mysql",
    name: "MySQL",
    description: "Banco de dados MySQL do cliente — consultar dados (SELECT) no fluxo",
    icon: "https://logo.clearbit.com/mysql.com",
    color: "#00758F",
    fields: [
      { name: "host", label: "Host (precisa ser acessível pela internet)", placeholder: "db.seucliente.com.br" },
      { name: "port", label: "Porta", placeholder: "3306" },
      { name: "user", label: "Usuário (recomendado: read-only dedicado)", placeholder: "readonly_user" },
      { name: "password", label: "Senha (ao editar, deixe em branco para manter)", secret: true },
      { name: "database", label: "Database", placeholder: "nome_do_banco" },
    ],
  },
];

export const byType = type => CATALOG.find(c => c.type === type);
